// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"SectionFAQ_sectionContainer__IgcQw","sectionHeader":"SectionFAQ_sectionHeader__dAP4H"};